import { sum } from "./sum";
import { RowComputeParams } from "./types";
import { MetricsKind } from "helpers/metrics/types";
import { safeParseFloat } from "lib/number";

export const AVERAGE_DEPTH = (params: RowComputeParams) => {
    const { mainRowNodes, getterParams, gridViewRef } = params;

    const planRows: any = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.PLAN_ROWS,
        mainRowNodes
    );
    const unitsValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.UNITS,
        mainRowNodes
    );

    if (planRows.length === 0) {
        return null;
    }

    const planRowsSum = sum(planRows);
    const totalUnits = sum(unitsValues);

    return safeParseFloat(totalUnits / planRowsSum, 0);
};
